import { useNavigate } from "react-router-dom";
import { useNews } from "@/hooks/useSupabaseData";

export default function LatestNews() {
  const navigate = useNavigate();
  const { news, loading } = useNews({ limit: 8 });

  if (loading) {
    return (
      <section className="w-full py-8 md:py-12">
        <div className="w-full px-4 md:px-8">
          <div className="h-8 w-48 bg-alvinegro-light rounded-lg mb-6 animate-pulse"></div>
          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4 md:gap-6">
            {Array.from({ length: 4 }).map((_, i) => (
              <div key={i} className="space-y-3 animate-pulse">
                <div className="aspect-[4/3] bg-alvinegro-light rounded-2xl"></div>
                <div className="h-4 bg-alvinegro-light rounded w-full"></div>
                <div className="h-3 bg-alvinegro-light rounded w-3/4"></div>
              </div>
            ))}
          </div>
        </div>
      </section>
    );
  }

  const firstRow = news.slice(0, 4);
  const secondRow = news.slice(4, 8);

  return (
    <section className="w-full py-8 md:py-12">
      <div className="w-full px-4 md:px-8">
        <div className="flex items-center justify-between mb-6 md:mb-8">
          <h2 className="font-serif font-bold text-2xl md:text-3xl text-alvinegro-black">
            Ãšltimas NotÃ­cias
          </h2>
          <button
            onClick={() => navigate("/noticias")}
            className="text-sm font-medium text-alvinegro-muted hover:text-alvinegro-black transition-colors cursor-pointer whitespace-nowrap"
          >
            Ver todas
            <i className="ri-arrow-right-line ml-1"></i>
          </button>
        </div>

        <div className="mt-6 md:mt-8 grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4 md:gap-6">
          {firstRow.map((item) => (
            <div
              key={item.id}
              className="group cursor-pointer"
              onClick={() => navigate(`/noticias/${item.slug}`)}
            >
              <div className="relative rounded-2xl overflow-hidden aspect-[4/3] mb-3">
                <img
                  src={item.image_url || "https://readdy.ai/api/search-image?query=Football%20match%20action%20professional%20sports%20photography%20dramatic&width=800&height=600&seq=news&orientation=landscape"}
                  alt={item.title}
                  className="w-full h-full object-cover transition-transform duration-500 group-hover:scale-105"
                />
                <div className="absolute inset-0 bg-gradient-to-t from-black/60 via-transparent to-transparent opacity-0 group-hover:opacity-100 transition-opacity"></div>
                <span className="absolute top-3 right-3 bg-alvinegro-black/80 text-white text-xs font-medium px-2.5 py-1 rounded-full">
                  {item.category}
                </span>
              </div>
              <h3 className="font-semibold text-sm md:text-base text-alvinegro-black leading-snug line-clamp-2 group-hover:text-alvinegro-gray transition-colors">
                {item.title}
              </h3>
              <p className="text-alvinegro-muted text-xs md:text-sm mt-1 line-clamp-2">
                {item.subtitle}
              </p>
              <div className="flex items-center gap-2 mt-2 text-xs text-alvinegro-muted">
                <span>{item.published_at ? new Date(item.published_at).toLocaleDateString("pt-BR") : ""}</span>
              </div>
            </div>
          ))}
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4 md:gap-6">
          {secondRow.map((item) => (
            <div
              key={item.id}
              className="group cursor-pointer"
              onClick={() => navigate(`/noticias/${item.slug}`)}
            >
              <div className="relative rounded-2xl overflow-hidden aspect-[4/3] mb-3">
                <img
                  src={item.image_url || "https://readdy.ai/api/search-image?query=Football%20match%20action%20professional%20sports%20photography%20dramatic&width=800&height=600&seq=news&orientation=landscape"}
                  alt={item.title}
                  className="w-full h-full object-cover transition-transform duration-500 group-hover:scale-105"
                />
                <div className="absolute inset-0 bg-gradient-to-t from-black/60 via-transparent to-transparent opacity-0 group-hover:opacity-100 transition-opacity"></div>
                <span className="absolute top-3 right-3 bg-alvinegro-black/80 text-white text-xs font-medium px-2.5 py-1 rounded-full">
                  {item.category}
                </span>
              </div>
              <h3 className="font-semibold text-sm md:text-base text-alvinegro-black leading-snug line-clamp-2 group-hover:text-alvinegro-gray transition-colors">
                {item.title}
              </h3>
              <p className="text-alvinegro-muted text-xs md:text-sm mt-1 line-clamp-2">
                {item.subtitle}
              </p>
              <div className="flex items-center gap-2 mt-2 text-xs text-alvinegro-muted">
                <span>{item.published_at ? new Date(item.published_at).toLocaleDateString("pt-BR") : ""}</span>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
